import { userActionTypes } from '../actions/types';

const initialState = {
  users: [],
  status: null,
  usersCount: 0,
  page: 1,
  totalPages: 0,
  total: 0,
  loading: false,
  error: null,
  activeUsersRequestId: null,
  dashboardStats: null,
  byDate: [],
};

export function user(state = initialState, action) {
  switch (action.type) {
    case userActionTypes.FETCH_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        activeUsersRequestId: action.meta && action.meta.requestId,
      };

    case userActionTypes.FETCH_USERS_SUCCESS:
      if (state.activeUsersRequestId !== (action.meta && action.meta.requestId)) {
        return state;
      }
      return {
        ...state,
        loading: false,
        error: null,
        users: action.payload.users,
        page: action.payload.page,
        totalPages: action.payload.totalPages,
        total: action.payload.total,
        activeUsersRequestId: null,
      };

    case userActionTypes.FETCH_USERS_FAILURE:
      if (state.activeUsersRequestId !== (action.meta && action.meta.requestId)) {
        return state;
      }
      return {
        ...state,
        loading: false,
        error: action.error,
        activeUsersRequestId: null,
      };

    case userActionTypes.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userActionTypes.GETALL_SUCCESS:
      if (action.count) {
        return {
          ...state,
          usersCount: action.usersCount,
          loading: false,
        };
      } else {
        return {
          ...state,
          users: action.users,
          usersCount: action.usersCount,
          loading: false,
        };
      }
    case userActionTypes.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case userActionTypes.GET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        user: null,
        designs: [],
      };
    case userActionTypes.GET_SUCCESS:
      return {
        ...state,
        user: action.user,
        loading: false,
        error: null,
      };
    case userActionTypes.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case userActionTypes.STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userActionTypes.STATISTICS_SUCCESS:
      return {
        ...state,
        byDate: action.users,
        loading: false,
      };
    case userActionTypes.STATISTICS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case userActionTypes.UPDATE_REQUEST:
      return {
        ...state,
        updateState: 'updating',
        error: null,
      };
    case userActionTypes.UPDATE_SUCCESS:
      return {
        ...state,
        updateState: 'updated',
      };
    case userActionTypes.UPDATE_FAILURE:
      return {
        ...state,
        updateState: 'failed',
        error: action.error,
      };
    case userActionTypes.DELETE_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        deleting: true,
        deleted: false,
        items: state.items.map(user =>
          user.id === action.id ? { ...user, deleting: true } : user,
        ),
      };
    case userActionTypes.DELETE_SUCCESS:
      // remove deleted user from state
      return {
        ...state,
        deleting: false,
        deleted: true,
        items: state.items.filter(user => user.id !== action.id),
      };
    case userActionTypes.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user
      return {
        ...state,
        deleting: false,
        deleted: false,
        items: state.items.map(user => {
          if (user.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { ...userCopy } = user;
            // return copy of user with 'deleteError:[error]' property
            return { ...userCopy, deleteError: action.error };
          }

          return user;
        }),
      };
    case userActionTypes.CHANGE_PROFILE_PICTURE_REQUEST:
      return {
        ...state,
        changingAvatarState: 'request',
      };
    case userActionTypes.CHANGE_PROFILE_PICTURE_SUCCESS:
      return {
        ...state,
        changingAvatarState: 'success',
      };
    case userActionTypes.CHANGE_PROFILE_PICTURE_FAILURE:
      return {
        ...state,
        changingAvatarState: 'failure',
      };
    case userActionTypes.GET_DESIGNS_REQUEST:
      return {
        ...state,
        designsState: 'request',
        designs: [],
      };
    case userActionTypes.GET_DESIGNS_SUCCESS:
      return {
        ...state,
        designsState: 'success',
        designs: action.designs,

      };
    case userActionTypes.GET_DESIGNS_FAILURE:
      return {
        ...state,
        designsState: 'failure',
      };
    case userActionTypes.GET_DASHBOARD_STATS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userActionTypes.GET_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardStats: action.stats,
      };
    case userActionTypes.GET_DASHBOARD_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
